<form id="dp-form-details" [formGroup]="form" class="row pane-container" (ngSubmit)="onSave()">
  <div class="col-12 left-pane">
    <app-digital-property-form-details
      [canEditName]="canEditName$ | async"
      [canEditProperty]="canEditProperty$ | async"
      [canEditTool]="canEditTool$ | async"
      [workspaceId]="workspaceId"
      [digitalProperty]="digitalProperty"
      [formValidationRequest$]="formValidationRequest"
      (formChanged)="detailsChanged($event)"
    ></app-digital-property-form-details>
  </div>
</form>
<div *appHasPermissions="readMobileAppsRequiredSecurity">
  @if (isMobile) {
    <div class="col-12" data-test-id="mobile-apps-field">
      <label class="label mb-1 text-nowrap">{{ 'add_app' | translate }}</label>
      @if ($isUploading()) {
        <ds-banner
          class="d-flex my-3"
          data-test-id="upload-app-info-banner"
          [state]="DsBannerState.info"
          [showTitle]="false"
          [showAction]="false"
          [showCloseButton]="true"
        >
          <div ds-banner-body>
            {{ 'app_uploading_info_banner_message' | translate }}
          </div>
        </ds-banner>
      }
      <app-emulator-app-table
        [digitalProperty]="digitalProperty"
        (mobileAppsLoaded)="onMobileAppsLoaded($event)"
      ></app-emulator-app-table>
    </div>
  }
</div>
